<template>
  <b-card
    no-body
    class="p-3"
  >
    <b-row >
      <b-col
        cols="12"
      >
        <validation-observer ref="formRef">
          <b-form @submit.prevent>
            <b-row>
              <!-- Cashbank Account Field -->
              <b-col cols="12" md="4">
                <b-form-group
                  :label="$t(`apps.transactions.sales.payment.singular.depositTo`)"
                  label-for="cashbank-account"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cashbank"
                    rules="required"
                  >
                    <v-select
                      v-if="company.plan_id > 2"
                      id="cashbank-account"
                      ref="firstFocusSelectInput"
                      v-model="form.cashbankId"
                      :options="LOV.cashbankCodeAccounts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <v-select
                      v-else
                      id="cashbank-account"
                      ref="firstFocusSelectInput"
                      v-model="form.accountId"
                      :options="LOV.cashbankAccounts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group
                  :label="$t(`apps.transactions.sales.payment.singular.receiveFrom`)"
                  label-for="contacts"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="contact"
                    rules="required"
                  >
                    <v-select
                      id="contacts"
                      v-model="form.contactId"
                      :options="LOV.contacts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Date Field -->
              <b-col cols="12" md="2">
                <b-form-group
                  :label="$t('globalSingular.date')"
                  label-for="date"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="date"
                    rules="required"
                  >
                    <flat-pickr
                      id="date"
                      :config="dateFormat"
                      v-model="form.date"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Due Date Field -->
              <b-col cols="12" md="2">
                <b-form-group
                  :label="$t('globalSingular.dueDate')"
                  label-for="due-date"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="date"
                    rules="required"
                  >
                    <flat-pickr
                      id="due-date"
                      :config="dateFormat"
                      v-model="form.dueDate"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <!-- Transaction No Field -->
              <b-col cols="12" md="2">
                <b-form-group
                  :label="$t('globalSingular.code')"
                  label-for="code"
                >
                  <b-form-input
                    id="code"
                    v-model="form.code"
                    placeholder="CI-2021020001"
                    :disabled="actions.isPreview"
                  />
                </b-form-group>
              </b-col>
              <!-- Tags Field -->
              <b-col cols="12" md="4">
                <b-form-group
                  :label="$t('globalSingular.tags')"
                  label-for="tags"
                >
                  <v-select
                    v-model="form.tags"
                    id="tags"
                    label="name"
                    taggable
                    multiple
                    push-tags
                    :options="LOV.tags"
                    :reduce="field => field.id"
                    :create-option="field => ({id: Date.now(), name: field})"
                    @option:created="pushTags"
                    :selectable="option => !actions.isPreview"
                  />
                </b-form-group>
              </b-col>
              <!-- Description Field -->
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$t('globalSingular.notes')"
                  label-for="notes"
                >
                  <b-form-textarea
                    id="notes"
                    v-model="form.description"
                    :placeholder="!actions.isPreview ? $t('globalSingular.description') : null"
                  />
                </b-form-group>
              </b-col>
            </b-row>


            <b-table
              id="refFormTable"
              ref="refFormTable"
              responsive
              no-provider-paging
              no-provider-filtering
              :fields="tableColumns"
              :items="detailInvoicePayment"
              primary-key="id"
              show-empty
              class="mt-2 position-relative"
            >
              <!-- Custom Header Column -->
              <template #head(actions)>
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="mx-auto"
                />
              </template>
              <!-- Styling width -->
              <!-- Column: Account -->
              <!-- <template #cell(invoiceId)="{ index }">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="account"
                    rules="required"
                    :vid="`detail-${index}`"
                  >
                    <v-select
                      id="account-type"
                      v-model="form.details[index].accountId"
                      :options="LOV.accounts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </template> -->
              <!-- Column: Invoice No -->
              <template #cell(rowNumber)="{ index }">
                <b-form-group>
                    <b-form-input v-model="form.details[index].rowNumber" disabled />
                    <!-- <span>{{form.details[index].rowNumber}}</span> -->
                </b-form-group>
              </template>
              <!-- Column: Invoice No -->
              <template #cell(invoiceNo)="{ index }">
                <b-form-group>
                    <b-form-input v-model="form.details[index].invoiceNo" disabled />
                </b-form-group>
              </template>
              <!-- Column: Invoice Amount -->
              <template #cell(billAmount)="{ index }">
                <b-form-group>
                    <cleave
                      :key="index"
                      v-model.number="form.details[index].billAmount"
                      class="text-right form-control"
                      :options="numeric"
                      placeholder="10,000"
                      disabled
                    />
                </b-form-group>
              </template>
              <!-- Column: Outstanding Amount -->
              <template #cell(outstandingAmount)="{ index }">
                <b-form-group>
                    <cleave
                      :key="index"
                      v-model.number="form.details[index].outstandingAmount"
                      class="text-right form-control"
                      :options="numeric"
                      placeholder="10,000"
                      disabled
                    />
                </b-form-group>
              </template>
              <!-- Column: PaymentAmount -->
              <template #cell(amount)="{ index }">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="amount"
                    :rules="`required|max_value:${form.details[index].outstandingAmount}`"
                    :vid="`detail-${index}`"
                  >
                    <cleave
                      :key="index"
                      v-model.number="form.details[index].amount"
                      :state="errors.length > 0 ? false:null"
                      class="text-right form-control"
                      :options="numeric"
                      placeholder="10,000"
                      @blur="sumAmount"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="{ index }">
                <b-button
                  variant="flat-danger"
                  class="btn-icon invoice-edit-input"
                  :disabled="form.details.length <= 1"
                  @click="removeRow(form.details[index].rowNumber)"
                >
                  <feather-icon icon="MinusIcon" />
                </b-button>
              </template>
              <!-- Costum Footer -->
              <template v-slot:custom-foot="{}">
                <b-tr>
                  <b-td class="pl-0" colspan="2">
                    &nbsp;
                  </b-td>
                  <b-td class="text-right">
                    <div class="mb-0 h5 font-weight-bolder">{{ $t('globalSingular.totalPaymentAmount') }}</div>
                  </b-td>
                  <b-td class="text-right">
                    <div class="mb-0 h5 font-weight-bolder">{{ formatCurrency(form.amount) }}</div>
                  </b-td>
                  <b-td>&nbsp;</b-td>
                </b-tr>
                <b-tr v-for="(field, index) in deductionPayment" :key="index" >
                  <b-td class="pl-0 border-0 " colspan="1">
                    &nbsp;
                  </b-td>
                  <b-td class="pl-5 text-right align-top border-0" colspan="2">
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        name="account"
                        rules="required"
                        :vid="`detail-${index + 1}`"
                      >
                        <v-select
                          id="deduction-type"
                          v-model="form.details[index + 1].deductionAccountId"
                          :options="LOV.accounts"
                          :reduce="field => field.id"
                          label="label"
                          :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-td>
                  <b-td class="text-right align-top border-0">
                    <validation-provider
                      #default="{ errors }"
                      name="amount"
                      :rules="`required|max_value:${form.details[index].amount}`"
                      :vid="`detail-${index + 1}`"
                    >
                      <cleave
                        :key="index + 1"
                        v-model.number="form.details[index + 1].deductionAmount"
                        :state="errors.length > 0 ? false:null"
                        class="text-right form-control text-danger"
                        :options="numeric"
                        placeholder="10,000"
                        @blur="sumAmount"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-td>
                  <b-td class="border-0">
                    <b-button
                      variant="flat-danger"
                      class="btn-icon invoice-edit-input"
                      @click="removeRow(field.rowNumber)"
                    >
                      <feather-icon icon="MinusIcon" />
                    </b-button>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td class="pl-0 border-0 " colspan="2">
                    &nbsp;
                  </b-td>
                  <b-td class="text-right border-0">
                    <!-- <div class="mb-0 h5 font-weight-bolder">{{ $t('globalSingular.totalPaymentAmount') }}</div> -->
                    &nbsp;
                  </b-td>
                  <b-td class="text-right border-0">
                    <b-button
                      variant="flat-primary"
                      class="btn-icon invoice-edit-input"
                      @click="addDeduction"
                    >
                      <feather-icon icon="PlusIcon" />
                      Add deduction
                    </b-button>
                  </b-td>
                  <b-td class="border-0">&nbsp;</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="pl-0 border-0" colspan="2">
                    &nbsp;
                  </b-td>
                  <b-td class="text-right border-0">
                    <div class="mb-0 h4 font-weight-bolder">{{ $t('globalSingular.moneyReceived') }}</div>
                  </b-td>
                  <b-td class="text-right border-0">
                    <div class="mb-0 h4 font-weight-bolder">{{ totalMoneyWillReceive }}</div>
                  </b-td>
                  <b-td class="border-0">&nbsp;</b-td>
                </b-tr>
              </template>
            </b-table>

            <div class="mt-3 d-flex flex-sm-column flex-md-row justify-content-between">
              <b-button
                class="mb-sm-1 mb-md-0"
                :variant="actions.isPreview ? 'outline-secondary' : 'outline-primary'"
                :to="{ name: 'apps-transactions-sales-payment-list' }"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                />
                {{ $t('globalActions.backToList') }}
              </b-button>

              <b-button
                v-if="actions.isPreview"
                class=" mb-sm-1 mb-md-0"
                variant="outline-danger"
                @click="handleDelete"
              >
                <feather-icon
                  icon="Trash2Icon"
                />
                {{ $t('globalActions.delete') }}
              </b-button>

              <b-button
                v-if="!actions.isPreview"
                variant="primary"
                type="submit"
                @click="handleSubmit"
              >
                <feather-icon
                  icon="SaveIcon"
                />
                {{ actions.isEditMode ? $t('globalActions.update') : $t('globalActions.create') }}
              </b-button>

              <b-button
                v-else
                variant="outline-primary"
                @click="changeToEdit"
              >
                <feather-icon
                  icon="EditIcon"
                />
                {{ $t('globalActions.changeToEdit') }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BTr,
  BTd,
  BFormGroup,
  BFormInput,
  BForm,
  BFormTextarea,
  BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import { ref, onMounted, computed, toRefs } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, maxValue } from '@validations'
import { formatCurrency } from '@/utils/formatter'
import VuexStore from '@/store'

import useFormResource from '@/comp-functions/useFormResource'
import usePushTags from '@/comp-functions/utils/usePushTags'
import useLocalization from '@/comp-functions/utils/useLocalization'

export default {
  props: {
    id: String
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BTr,
    BTd,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    Cleave
  },
  setup (props) {
    const {
      // paramsId,
      // routeParams,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    } = useFormResource({ url: 'transaction/sales/payment', localeContextPath: 'apps.transactions.sales.payment.singular.payment', redirectPathName: 'apps-transactions-sales-invoice' })

    const company = computed(() => {
      return VuexStore.state.user.currentCompany
    })

    const { id } = toRefs(props)

    const { $t } = useLocalization()

    const LOV = ref({
      cashbankAccounts: [],
      cashbankCodeAccounts: [],
      contacts: [],
      accounts: [],
      tags: []
    })

    const getCashbankAccount = async () => {
      LOV.value.cashbankAccounts = await get({ url: 'master/accounts/child?account_subtype_code=CASHBANK'})
    }

    const getCashbankCode = async () => {
      LOV.value.cashbankCodeAccounts = await get({ url: 'master/cashbank'})
    }

    const getAccounts = async () => {
      LOV.value.accounts = await get({ url: 'master/accounts?is_account_parent=true'})
    }

    const getContacts = async () => {
      LOV.value.contacts = await get({ url: 'value/contact/customer'})
    }

    const getTags = async () => {
      LOV.value.tags = await get({ url: 'value/tag'})
    }

    const tableColumns = ref([])

    const form = ref({
      accountId: '',
      cashbankId: '',
      contactId: '',
      code: '',
      paymentTypeCode: '',
      date: '',
      tags: [],
      description: '',
      amount: 0,
      deductionAmount: 0,
      details: []
    })

    const dateFormat = ref({ dateFormat: 'd/m/Y', allowInput: true })

    const numeric = ref({
      numeral: true,
      numeralThousandsGroupStyle: 'thousand'
    })

    /**
     * @remark sum of amount and deduction amount when these value change
    */
    const sumAmount = () => {
      form.value.amount = form.value.details.reduce((accumulator, {amount}) => accumulator + amount, 0)
      form.value.deductionAmount = form.value.details.reduce((accumulator, {deductionAmount}) => accumulator + deductionAmount, 0)
    }

    // will get data to show the preview
    const getDataPreview = async () => {
      const data = await get({ url: `transaction/sales/invoice/${id.value}`})
      form.value.contactId = data.contact_id
      const invoice = {
        rowNumber: 1,
        invoiceId: id.value,
        invoiceNo: data.code,
        billAmount: parseFloat(data.sum_of_bill_amount),
        outstandingAmount: parseFloat(data.outstanding_amount),
        amount: 0,
        deductionAccountId: null,
        deductionAmount: 0
      }
      form.value.details.push(invoice)
    }

    // add deduction amount
    const addDeduction = () => {
      form.value.details.push({
        rowNumber: form.value.details.length + 1,
        invoiceId: id.value,
        invoiceNo: '',
        billAmount: 0,
        outstandingAmount: 0,
        amount: 0,
        deductionAccountId: null,
        deductionAmount: null
      })
    }

    const totalMoneyWillReceive = computed(() => {
      const total = form.value.amount - form.value.deductionAmount
      return formatCurrency(total)
    })

    const detailInvoicePayment = computed(() => form.value.details.filter(field => field.billAmount > 0))
    const deductionPayment = computed(() => form.value.details.filter(field => field.billAmount === 0))

    // Remove row deduction / payment list
    const removeRow =  (rowNumber) => {
      const index = form.value.details.findIndex(field => field.rowNumber === rowNumber)
      form.value.details.splice(index, 1)
      sumAmount()
    }

    onMounted(() => {
      getCashbankAccount()
      getAccounts()
      getTags()
      getContacts()
      if (id) {
        getDataPreview()
      }
      if (company.value.plan_id > 2) {
        getCashbankCode()
      }
      tableColumns.value = [
        // { key: 'rowNumber', label: '#', width: '10%', thClass: 'bg-transparent pl-0', tdClass: 'align-top pl-0' },
        { key: 'invoiceNo', label: $t('apps.transactions.sales.payment.singular.invoiceNo'), width: '24%', thClass: 'bg-transparent pl-0 width-25-per', tdClass: 'align-top pl-0' },
        { key: 'billAmount', label: $t('apps.transactions.sales.payment.singular.invoiceAmount'), width: '24%', thClass: 'bg-transparent text-right width-25-per', tdClass: 'align-top text-right'},
        { key: 'outstandingAmount', label: $t('apps.transactions.sales.payment.singular.outstandingAmount'), width: '24%', thClass: 'bg-transparent text-right width-25-per', tdClass: 'align-top text-right'},
        { key: 'amount', label: $t('apps.transactions.sales.payment.singular.paymentAmount'), width: '24%', thClass: 'bg-transparent text-right width-25-per', tdClass: 'align-top text-right'},
        { key: 'actions', width: '12%', thClass: 'bg-transparent text-right width-10-per  pr-0', tdClass: 'align-top text-right pr-0'}
      ]
    })

    const { pushTagsToAPI } = usePushTags()
    const pushTags = async newTag => {
      const id = await pushTagsToAPI(newTag)
      form.value.tags[form.value.tags.findIndex(val => val === newTag.id)] = id
    }

    return {
      company,
      pushTags,
      required,
      maxValue,
      LOV,
      tableColumns,
      detailInvoicePayment,
      deductionPayment,
      form,
      addDeduction,
      removeRow,
      totalMoneyWillReceive,
      dateFormat,
      formatCurrency,
      sumAmount,
      numeric,
      // paramsId,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    }
  },
  methods: {
    handleDelete () {
      this.destroy(this.$swal)
    },
    handleSubmit () {
      this.store({
        $swal: this.$swal,
        data: this.form,
        url: 'transaction/sales/payment'
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
